import { useCallback } from 'react'
import { trackEvent, trackPageView } from './gtm.js'

/**
 * Хук-обгортка над аналітикою для компонентів.
 * const { track } = useAnalytics()
 * track('cta_click', { variant: 'primary', location: 'hero' })
 */
export function useAnalytics() {
  const track = useCallback((event, params) => {
    trackEvent(event, params)
  }, [])

  const pageView = useCallback((name, params) => {
    trackPageView(name, params)
  }, [])

  return { track, pageView }
}
